import React from "react";
import { theme } from "../../../utils/theme";

const DAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

const OperatingHoursCard = ({
    form,
    setForm,
    isEditing,
    onEdit,
    onCancel,
    onSave,
    type = "printShop", // Default to printShop if type is not provided
}) => {
    const t = theme[type];

    const handleHourChange = (day, field, value) => {
        setForm((prev) => ({
            ...prev,
            workingHours: {
                ...prev.workingHours,
                [day]: {
                    ...prev.workingHours[day],
                    [field]: value,
                },
            },
        }));
    };

    return (
        <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">

            {/* HEADER */}
            <div className="px-[20px] py-[14px] border-b border-[#f0f1f3]">
                <div className="flex items-center justify-between">
                    <p className="font-semibold text-[15px] text-[#212326]">
                        Operating Hours
                    </p>

                    {isEditing ? (
                        <div className="flex items-center gap-[8px]">
                            <button
                                onClick={onCancel}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onSave}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                                style={{ backgroundColor: t.primary }}
                            >
                                Save
                            </button>
                        </div>
                    ) : (
                        <button
                            onClick={onEdit}
                            className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                            style={{ backgroundColor: t.primary }}
                        >
                            Edit
                        </button>
                    )}
                </div>
            </div>

            {/* BODY */}
            <div className="p-[20px]">
                {!isEditing ? (
                    <div className="flex flex-col gap-[8px]">
                        {DAYS.map((day) => {
                            const data = form.workingHours?.[day];

                            return (
                                <div
                                    key={day}
                                    className="flex items-center justify-between py-[4px]"
                                >
                                    <span className="font-semibold text-[13px] text-[#717182] w-[100px]">
                                        {day}
                                    </span>

                                    {data?.open === false ? (
                                        <span className="font-semibold text-[13px] text-[#9298a0]">
                                            Closed
                                        </span>
                                    ) : (
                                        <span className="font-semibold text-[13px] text-[#212326]">
                                            {data?.from} - {data?.to}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="flex flex-col gap-[10px]">
                        {DAYS.map((day) => {
                            const data = form.workingHours?.[day];

                            return (
                                <div
                                    key={day}
                                    className="flex items-center gap-[12px]"
                                >
                                    <span className="font-semibold text-[13px] text-[#717182] w-[100px] shrink-0">
                                        {day}
                                    </span>

                                    <label className="flex items-center gap-[6px] shrink-0">
                                        <input
                                            type="checkbox"
                                            checked={!data?.open}
                                            onChange={(e) =>
                                                handleHourChange(
                                                    day,
                                                    "open",
                                                    !e.target.checked
                                                )
                                            }
                                            className="w-[16px] h-[16px]"
                                            style={{
                                                accentColor: t.primary,
                                            }}
                                        />
                                        <span className="font-semibold text-[12px] text-[#9298a0]">
                                            Closed
                                        </span>
                                    </label>

                                    {data?.open && (
                                        <div className="flex items-center gap-[8px]">
                                            <input
                                                type="time"
                                                value={data.from}
                                                onChange={(e) =>
                                                    handleHourChange(
                                                        day,
                                                        "from",
                                                        e.target.value
                                                    )
                                                }
                                                className="h-[36px] font-semibold rounded-[8px] border border-[#e4e5e7] px-[10px] text-[13px]"
                                            />

                                            <span className="text-[#9298a0]">
                                                -
                                            </span>

                                            <input
                                                type="time"
                                                value={data.to}
                                                onChange={(e) =>
                                                    handleHourChange(
                                                        day,
                                                        "to",
                                                        e.target.value
                                                    )
                                                }
                                                className="h-[36px] font-semibold rounded-[8px] border border-[#e4e5e7] px-[10px] text-[13px]"
                                            />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default OperatingHoursCard;
